<template>
  <div class="merchant-add">
    <GlobalInfoBar title="分享积分设置" content="通过赠送顾客积分，用于鼓励现有客户推荐好友入驻估价，推荐人估价下单可使用获得的积分加价。" />
    <GlobalChunk icon="edit" title="门店信息编辑" :padding="[32, 0, 95, 55]">
      <div class="basics">
        <div class="flex_action">
          <img class="line" style="width: 25px;height: 25px;" src="../../../assets/images/shareSet/share.png" alt="" />
          <p style="color:#333333;margin-bottom: 0px; font-size: 18px;">分享设置</p>
        </div>
        <div class="section_time">
          <span style="color: #FF687B;">*</span>
          <p>功能开关</p>
          <el-switch inactive-color="#bebebe" @change="handleSwitch" v-model="isEnable"></el-switch>
          <div class="top_right">
            <img style="width: 18px;" src="https://img.fanxinghuishou.cn/20230814/066640864.png" alt="">
            <span>关闭开关后，小程序“我的”页面不再展示分享有礼功能</span>
          </div>
        </div>
        <div class="section_time">
          <span style="color: #FF687B;">*</span>
          <p>上传分享海报： <span @click="seeSampleImage" style="color:#0981ff;text-decoration: underline; cursor: pointer;">查看示例图</span></p>
        </div>
        <div class="uploadImage">
          <ElImgUpload :exist-image="imageAll" @handleDelete="handleUploadDelete(imageAll)"
            @handleChange="handleUploadChange($event, imageAll)" />
        </div>
        <p style="margin-left: 67px;margin-top: -20px;font-size: 12px;">请上传小于2M的PNG/JPG格式图片 <span
            style="color:#0981ff;text-decoration: underline; cursor: pointer;" @click="download">下载海报模板</span></p>
      </div>
      <div class="basics flex_action" style="margin-bottom: 20px;">
        <img class="line" src="../../../assets/images/shareSet/yaoqing.png" alt="" />
        <p style="color:#333333; font-size: 18px;">奖励设置 <span style="color:#999999">(1积分价值等于1块钱)</span></p>
      </div>
      <el-row>
        <el-col :span="12">
          <GlobalForm :init-data="initData" :form-rules="formRules" :form-item-list="formItemList"
            @handleConfirm="handleConfirm" confirmBtnName="提交">
            <el-button slot="btnSlot" @click="FromBack">返回</el-button>
          </GlobalForm>
        </el-col>
      </el-row>
    </GlobalChunk>
    <el-image-viewer v-if="showViewer" :on-close="
      () => {
        showViewer = false;
      }
    " :url-list="imgList" />
  </div>
</template>

<script>
import {
  formValidateMobile,
  formValidateNumber,
  formValidateNumberEight,
} from '@/utils/form-validate'
import _api from '@/utils/request'
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
// import ElImgUpload from './elements/upload-element'
import ElImgUpload from '../../../components/global/components/elements/upload-element'
import { http } from "../../../utils/request/newIndex";
export default {
  name: 'merchant-add',
  components: {
    ElImgUpload,
    ElImageViewer
  },
  data() {
    return {
      showViewer: false,
      imgList: [],
      sumitdata: '',
      checkRadio: 1,
      goolgeShow: false,
      startTime: "",
      endTime: "",
      imageAll: "",
      isEnable: false,
      // ShowUserAccount: false,
      MerchantFormData: [],
      optionsProvince: {},
      optionsCity: [],
      optionsArea: [],
      addressInfo: {
        provinceID: '',
        cityID: '',
        areaID: '',
      },
      initData: {
        sharePointsLimit: '',
        usePointsLimit: '',
        usePointsMax: '',
      },
      formItemList: [
        {
          key: 'sharePointsLimit',
          zhenNumber: true,
          lableWidth: "163px",
          labelName: '每分享1人获得积分',
          placeholder: '请输入结算积分',
        },
        {
          key: 'usePointsLimit',
          zhenNumber: true,
          lableWidth: "163px",
          labelName: '单次使用积分估价门槛',
          placeholder: '请输入可使用积分的估价门槛',
        },
        {
          key: 'usePointsMax',
          zhenNumber: true,
          lableWidth: "163px",
          labelName: '单次最多可用积分',
          placeholder: '请输入单次可用积分最大值',
        }
      ],
      formRules: {
        sharePointsLimit: [
          {
            type: 'integer',
            required: true,
            trigger: 'blur',
            message: '请输入结算积分',
            max: 5000,
          },
        ],
        usePointsLimit: [
          {
            type: 'integer',
            required: true,
            trigger: 'blur',
            message: '请输入单次使用积分门槛',
            max: 5000,
          },
        ],
        usePointsMax: [
          {
            type: 'integer',
            required: true,
            trigger: 'blur',
            message: '请输入单次最多可用积分',
            max: 5000,
          },
        ],
      },
    }
  },
  mounted() {
    http.pontsconfigInfo().then((res) => {
      if (res.code === 1) {
        console.log(res);
        this.optionsProvince = res.data
        this.initData.sharePointsLimit = this.optionsProvince.sharePointsLimit ? this.optionsProvince.sharePointsLimit : ''
        this.initData.usePointsLimit = this.optionsProvince.usePointsLimit ? this.optionsProvince.usePointsLimit : ''
        this.initData.usePointsMax = this.optionsProvince.usePointsMax ? this.optionsProvince.usePointsMax : ''
        this.isEnable = this.optionsProvince.isSwitch ? true : false;
        this.imageAll = this.optionsProvince.postersImg;
      }
    })
  },
  methods: {
    uplodimg() {
      let base = "https://fxhs-1307601393.cos.ap-chengdu.myqcloud.com/20221227/A6KIEvw4PyKH3af8d003e1158f5b28643e2be424e496.jpg"
      this.downloadIamge(base, "haibao.png")
    },
    download() {
      const link = document.createElement("a");
      link.href = "/static/分享海报模板.zip";
      link.setAttribute("download", "海报模板.zip");
      document.body.appendChild(link);
      link.click();
    },
    // downloadIamge(imgsrc, name) {
    //   //下载图片地址和图片名
    //   var image = new Image();
    //   // 解决跨域 Canvas 污染问题
    //   image.setAttribute("crossOrigin", "anonymous");
    //   image.onload = function () {
    //     var canvas = document.createElement("canvas");
    //     canvas.width = image.width;
    //     canvas.height = image.height;
    //     var context = canvas.getContext("2d");
    //     context.drawImage(image, 0, 0, image.width, image.height);
    //     var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据'
    //     var a = document.createElement("a"); // 生成一个a元素
    //     var event = new MouseEvent("click", {
    //       bubbles: true,
    //       cancelable: true,
    //       view: window
    //     }); // 创建一个单击事件
    //     a.download = name || "photo"; // 设置图片名称
    //     a.href = url; // 将生成的URL设置为a.href属性
    //     a.dispatchEvent(event); // 触发a的单击事件
    //   };
    //   image.src = imgsrc;
    // },
    // 查看示例图大图
    seeSampleImage() {
      this.imgList = [];
      this.showViewer = true;
      let url = "https://img.fanxinghuishou.cn/20230814/565553540.png"
      this.imgList.push(url);
    },
    // 上传图片后，将图片信息保存到对应参数中
    handleUploadChange(url, key) {
      console.log(url, key);
      this.imageAll = url
    },
    // 如果删除图片
    handleUploadDelete(key) {
      this.imageAll = ''
    },
    handleSwitch(e) {
      console.log(e);
    },
    handleConfirm(data, cd) {
      console.log(data)
      console.log(this.isEnable)
      console.log(this.imageAll)
      if (!this.imageAll) {
        this.$message.error('请上传分享海报！')
        return
      }
      this.optionsProvince.isSwitch = this.isEnable;
      this.optionsProvince.postersImg = this.imageAll
      this.optionsProvince.sharePointsLimit = Number(data.sharePointsLimit);
      this.optionsProvince.usePointsLimit = Number(data.usePointsLimit);
      this.optionsProvince.usePointsMax = Number(data.usePointsMax);
      console.log(this.optionsProvince, "this.optionsProvince");
      this.sumitclick();
    },
    //提交按钮
    sumitclick() {
      console.log(this.optionsProvince);
      http.updatepontsInfo(this.optionsProvince).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: '修改成功',
            type: 'success',
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    BeautifulClosed() {
      this.goolgeShow = false
    },

    FromBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
/deep/.el-form-item__label {
  width: 163px !important;
}

.top_right {
  display: flex;
  align-items: center;
  margin-left: 60px;
}

.section_time {
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  span {
    color: #FF687B;
    margin-right: 4px;
    margin-left: 15px;
  }

  p {
    font-size: 14px;
    color: #666666;
    padding-right: 16px;
  }

  width: 80%;
}

.basics {
  padding: 0 20px;
  margin-bottom: 35px;

  >div {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }

  p,
  span {
    font-size: 14px;
    color: #666666;
    margin-right: 4px
  }
}

.flex_action {
  display: flex;
  align-items: center;

  .line {
    width: 30px;
    height: 30px;
    margin-bottom: 0px;
    margin-right: 10px;
  }
}

.uploadImage {
  margin-left: 70px;
}

.merchant-add {
  .el_from {
    margin-left: -120px;
  }
}

/deep/.global-chunk_header {
  display: none;
}

/deep/ .el-form-item__content {
  // margin-top: 70px;
}

.el-dialog__body .acc_dialog_text1 {
  margin-bottom: 40rpx;
  color: red;
}

.command {
  display: flex;
  align-items: center;
}

.command {
  display: flex;
  align-items: center;
}

.command .el-input {
  width: 80%;
}

/deep/ .el-select {
  width: 100%;
}
</style>
